var map = {
	"./bottom_bar.png": "b086",
	"./first-outer.svg": "9684",
	"./left_opening.svg": "0965",
	"./middle.svg": "7fe5",
	"./middle_opening.svg": "c344",
	"./oval.png": "91bf",
	"./right_opening.svg": "f866",
	"./round.png": "4eb0",
	"./second-outer.svg": "611e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b440";